<template>
  <div class="card">
    <div class="number_wrapper">
      <h1>{{ this.data }}</h1>
    </div>
    <div class="info_wrapper">
      <p>{{ this.meta.name }}</p>
      <tt>{{ this.meta.info }}</tt>
    </div>
  </div>
</template>

<script>
export default {
  name: "NumberChart",
  props: {
    meta: {
      type: Object,
      required: true,
    },
    data: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
div {
  color: var(--secondary-fg);
}

h1 {
  font-size: 4em;
  margin: 0;
}

p {
  margin: 0;
  padding: 0.25em 1em;
}

tt {
  color: var(--gray-600);
}

.card {
  display: flex;
  place-items: center;
  flex-flow: column nowrap;
  padding: 1em;
}

.number_wrapper {
  display: flex;
  place-items: center;
}

.info_wrapper {
  display: flex;
  place-items: center;
  flex-flow: column nowrap;
}
</style>
